import {
  LoadActivePlansComplete,
  LoadPlansForProductComplete,
  LoadPlansForTokeetComplete,
  SubscribePlanForProduct,
  SubscribePlanForProductComplete,
  SubscribePlanForTokeet,
  SubscribePlanForTokeetComplete,
  UnsubscribePlan,
  UnsubscribePlanComplete,
} from './plan.actions'
import { adapter, initialState, State } from './plan.state'
import * as R from 'ramda'
import * as lodash from 'lodash'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'
import { Action, createReducer, on } from '@ngrx/store'

export const reducer = createReducer(
  initialState,
  on(UnsubscribePlan, SubscribePlanForProduct, SubscribePlanForTokeet, (state) => ({ ...state, isUpdatingPlan: true })),
  on(UnsubscribePlanComplete, (state, { product, subscriptions }) => ({
    ...state,
    activePlans: lodash.keyBy(subscriptions, 'product'),
    isUpdatingPlan: false,
  })),
  on(SubscribePlanForTokeetComplete, (state, { planSubscription }) => ({
    ...state,
    activePlans: {
      ...state.activePlans,
      [ProductsForPlan.Tokeet]: planSubscription,
    },
    isUpdatingPlan: false,
  })),
  on(SubscribePlanForProductComplete, (state, { planSubscription, product }) => ({
    ...state,
    activePlans: {
      ...state.activePlans,
      [product]: planSubscription,
    },
    isUpdatingPlan: false,
  })),
  on(LoadPlansForTokeetComplete, (state, { plans }) =>
    adapter.addMany(plans, R.mergeDeepRight(state, { isPlansLoaded: { [ProductsForPlan.Tokeet]: true } }))
  ),
  on(LoadPlansForProductComplete, (state, { plans, product }) =>
    adapter.addMany(plans, R.mergeDeepRight(state, { isPlansLoaded: { [product]: true } }))
  ),
  on(LoadActivePlansComplete, (state, { card, activePlans, status }) => ({
    ...state,
    ...{ card, activePlans, status },
    isActivePlansLoaded: true,
  }))
)

export function planReducer(state: State | undefined, action: Action) {
  return reducer(state, action)
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors()
